<template>
  <div>
    <User :type="0" role="YSY00"></User>
  </div>
</template>
  <script>
import User from '../../system/user/index'
export default {
  name: 'Post',
  components: { User },
  data() {
    return {}
  },
  filters: {},
  created() {},
  computed: {},
  watch: {},
  methods: {},
}
</script>
